import * as tslib_1 from "tslib";
import { PremiumStorageOptionApril } from 'owa-premium-storage-option';
import { SubscriptionOptionApril } from 'owa-subscription-option';
import { DomainEnrollOption } from 'owa-domain-option';
import { getAccountInformation } from 'owa-storage-option';
import { getDomainState } from 'owa-domain-option';
import { trace } from 'owa-trace';
var premiumDashboardFeaturesSubCategory = {
    key: 'features',
    titleStringKey: 'options_premiumSubOption_Features',
    options: [PremiumStorageOptionApril, SubscriptionOptionApril, DomainEnrollOption],
    onSelected: function () {
        return loadPremiumFeatureDashBoard();
    },
};
function loadPremiumFeatureDashBoard() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getAccountInformation()];
                case 1:
                    _a.sent();
                    getDomainState();
                    return [2 /*return*/, true];
                case 2:
                    e_1 = _a.sent();
                    trace.warn(e_1.message);
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export default premiumDashboardFeaturesSubCategory;
//# sourceMappingURL=PremiumDashboardFeaturesSubCategory.js.map